module.exports = __webpack_public_path__ + "img/chart-tools.4e35b895.png";